// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { hammer16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-hammer': IconHammer;
    }
}

/**
 * The icon component for the 'hammer' icon
 */
export class IconHammer extends IconSvg {
    public constructor() {
        super(hammer16X16);
    }
}

registerIconSvg('icon-hammer', IconHammer);
export const iconHammerTag = 'nimble-icon-hammer';
